module.exports = __webpack_public_path__ + "static/corporate-training_barcelona-code-school-jikken-kobo-d06f5e0f0561153e489ff52c1541ab4d.png";